import { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 8fr;
  height: 100%;
  padding: 0;
`;

export const SidebarContainer = styled.div<{ rightAlign?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 700px;

  box-shadow: 0 0 0 transparent;
  border-left: 1px solid ${({ theme }) => theme.line.light};
  ${({ theme, rightAlign }) => !rightAlign && `border-left: 0; border-right: 1px solid ${theme.line.light};`};
`;

interface Props {
  body: ReactNode;
  sidebar: ReactNode;
}

export const SelectTemplateLayout: React.FC<Props> = ({ body, sidebar }) => {
  return (
    <Container>
      <SidebarContainer>{sidebar}</SidebarContainer>
      {body}
    </Container>
  );
};
